import { Box, Button } from "@mui/material";
import { useNavigate } from "react-router";

import { FilterDropdown } from "@shared/components";
import {
  ReferralListFilters,
  RejectModal,
  SummaryCards,
} from "@modules/partners/components";
import { DataGrid } from "@shared/components/DataGrid";
import { formatCurrency } from "@core/utils/masks";

import { useReferralsTab } from "./controller";
import { useReferralsColumns } from "./columns";

export function ReferralsTab() {
  const navigate = useNavigate();

  const {
    rows,
    loading,
    tableProps,
    summary,
    partners,
    rejectTarget,
    isRejecting,
    setRejectTarget,
    handleApprove,
    handleReject,
    refetch,
    translate,
  } = useReferralsTab();

  const columns = useReferralsColumns({
    translate,
    refetch,
    partners,
    onApprove: handleApprove,
    onReject: setRejectTarget,
  });

  return (
    <>
      {summary && (
        <Box sx={{ mb: 2 }}>
          <SummaryCards
            items={[
              {
                label: translate("v1/partner_admin.fields.referrals_count"),
                value: summary.referrals_count,
              },
              {
                label: translate("v1/partner_referral_admin.fields.sales_value"),
                value: formatCurrency(summary.total_sales),
              },
              {
                label: translate("v1/partner_referral_admin.fields.commission_value"),
                value: formatCurrency(summary.total_commission),
              },
            ]}
          />
        </Box>
      )}

      <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1, mb: 1 }}>
        <FilterDropdown initialValues={{ search: "", status: "", partner: "" }}>
          <ReferralListFilters />
        </FilterDropdown>
        <Button
          variant="contained"
          onClick={() => navigate("/partners/referrals/create")}
        >
          {translate("v1/partner_referral_admin.titles.create")}
        </Button>
      </Box>

      <DataGrid {...tableProps} rows={rows} columns={columns} loading={loading} />

      <RejectModal
        open={Boolean(rejectTarget)}
        loading={isRejecting}
        onClose={() => setRejectTarget(null)}
        onConfirm={handleReject}
      />
    </>
  );
}
